import type { RevalidateTrigger } from 'data/FHIRFetcher';
import type { Task } from 'fhir/r4';
import type PatientCDO from 'models/patient';
import React from 'react';
import { Header, Icon, Image, Label } from 'semantic-ui-react';
import * as Helpers from 'utils/Helpers';
import { formatPhoneNumber } from 'utils/utils';

import CancelTask from '../cancel';

import { HeaderContainer, HeaderTitle, LabelContainer } from './header.styles';

type TaskHeaderProps = {
  activity?: boolean | undefined;
  flatPatient: typeof PatientCDO;
  patientName: React.ReactNode;
  patientId: string;
  /**
   * `Patient.managingOrganization.reference` split on `/`, so absent whenever the
   * patient fetch has not resolved or the patient carries no managing organization.
   */
  patientOrg: string | undefined;
  onPatientSelected: (patientData: unknown) => void;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
  setLoader: React.Dispatch<React.SetStateAction<boolean>>;
  loader: boolean;
  tasksMutate: RevalidateTrigger;
  taskPayload: Task;
};

const TaskHeader: React.FC<TaskHeaderProps> = ({
  activity,
  flatPatient,
  patientName,
  patientId,
  patientOrg,
  onPatientSelected,
  setErrorMessage,
  setLoader,
  loader,
  tasksMutate,
  taskPayload,
}) => {
  const openPatientTab = () => {
    onPatientSelected(flatPatient);
  };

  return (
    <HeaderContainer>
      <HeaderTitle>
        <Header style={{ marginTop: 5 }} as="h2">
          TASK DETAIL
        </Header>
        {taskPayload.status !== 'cancelled' && (
          <CancelTask
            tasksMutate={tasksMutate}
            patientId={patientId}
            patientOrganizationId={patientOrg}
            setLoader={setLoader}
            loader={loader}
            taskPayload={taskPayload}
            setErrorMessage={setErrorMessage}
          />
        )}
      </HeaderTitle>
      {activity && (
        <LabelContainer onClick={openPatientTab}>
          <Label as="a" color="teal" image>
            <Image circular size="mini" src={'../../../images/' + Helpers.getImage(true)} />
            {patientName}
          </Label>
          {flatPatient?.memberId && (
            <Label color="teal">
              <Icon name="id card" color="black" /> {flatPatient?.memberId}
            </Label>
          )}
          {flatPatient?.language?.[0] && (
            <Label color="teal">
              <Icon name="language" color="black" />
              {flatPatient?.language?.[0]}
            </Label>
          )}
          {flatPatient?.org && (
            <Label color="teal">
              <Icon name="building" color="black" />
              {flatPatient?.org}
            </Label>
          )}
          {flatPatient?.provider && (
            <Label color="teal">
              <Icon name="user md" color="black" />
              {flatPatient?.provider}
            </Label>
          )}
          {flatPatient?.dob && flatPatient?.dob.length > 0 && (
            <Label color="teal">
              <Icon name="birthday" color="black" />
              {flatPatient?.dob}
            </Label>
          )}
          {flatPatient?.mobilePhone && flatPatient?.mobilePhone.length > 0 && (
            <Label color="teal">
              <Icon name="phone" color="black" />
              {formatPhoneNumber(flatPatient?.mobilePhone)}
            </Label>
          )}
        </LabelContainer>
      )}
    </HeaderContainer>
  );
};

export default TaskHeader;
